module.exports = __webpack_public_path__ + "img/parallaximg.658184d8.png";